import React from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import AboutPage from './pages/About';
import HomePage from './pages/Home';
function App() {
  return (
    <div className="App">

      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={HomePage}/>
          <Route exact path="/about" component={AboutPage}/>
          <Route exact path="/brands" component={AboutPage}/>
          <Route exact path="/category" component={AboutPage}/>
          <Route exact path="/category" component={AboutPage}/>
        </Switch>
      </BrowserRouter>
      
    </div>
  );
}

export default App;
